import { render, staticRenderFns } from "./HistorialDeTicketsHolder.vue?vue&type=template&id=28cab61e"
import script from "./HistorialDeTicketsHolder.vue?vue&type=script&lang=js"
export * from "./HistorialDeTicketsHolder.vue?vue&type=script&lang=js"
import style0 from "./HistorialDeTicketsHolder.vue?vue&type=style&index=0&id=28cab61e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports